import { getHtml } from "../apis/templateHtml";
import { getAllDo } from "../data/zodoData";
/**
 * DO検索
 */
export const setSelectDo = async () => {
    // DO名のドロップダウンリストを設定
    const inputDoName = document.getElementById('inputDoName');
    if (inputDoName) {
        inputDoName.innerHTML = userDoSelect("", false);
        console.log('DO名のドロップダウンリストを設定しました');
    }
    else {
        console.error('inputDoName要素が見つかりません');
    }
};
/**
 * DO検索
 */
export const setSearchDo = async () => {
    // DO検索のHTMLを取得
    const searchDoModal = document.getElementById('searchDoModal');
    const searchDoModalContent = await getHtml("/parts/serachDo.html");
    if (searchDoModalContent) {
        searchDoModal.innerHTML = searchDoModalContent;
    }
    // DO番号を取得
    const classSearchDoCode = document.querySelector('.js-search-do-code');
    // 開くボタンの実装
    if (classSearchDoCode) {
        classSearchDoCode.addEventListener('click', () => {
            searchDoModal?.classList.add('is-active');
        });
    }
    // DO名を取得
    const classSearchDoName = document.querySelector('.js-search-do-name');
    // 開くボタンの実装
    if (classSearchDoName) {
        classSearchDoName.addEventListener('click', () => {
            searchDoModal?.classList.add('is-active');
        });
    }
    //「閉じるボタン」をクリックしてモーダルを閉じる
    const closeSearchDoModal = document.querySelector('.js-search-do-modal-close');
    if (closeSearchDoModal) {
        closeSearchDoModal.addEventListener('click', () => {
            searchDoModal.classList.remove('is-active');
        });
    }
    //「モーダルの外側」をクリックしてモーダルを閉じる
    function modalOut(e) {
        if (e.target === searchDoModal) {
            searchDoModal?.classList.remove('is-active');
        }
    }
    addEventListener('click', modalOut);
    const doCondition = document.getElementById('doCondition');
    if (doCondition) {
        doCondition.innerHTML = userDoButton("");
    }
    const searchDoInput = document.getElementById('searchDoInput');
    if (searchDoInput) {
        searchDoInput.addEventListener('keyup', () => {
            doCondition.innerHTML = userDoButton(searchDoInput.value);
        });
    }
};
function userDoButton(searchWord) {
    let doList = "";
    let doCode = "";
    let doName = "";
    const doData = {
        do: getAllDo(),
    };
    for (let key in doData.do.do_data) {
        doCode = doData.do.do_data[key].do_code;
        doName = doData.do.do_data[key].do_name;
        if (searchWord === "" || doCode.match(searchWord) || doName.match(searchWord)) {
            doList +=
                '<button class="selectButton" type="button" onClick="inputDoCode.value = \'' + doCode + '\'; inputDoName.value = \'' + doName + '\'; searchDoModal.classList.remove(\'is-active\');">' + doCode + '：' + doName + '</button>';
        }
    }
    return doList;
}
function userDoSelect(searchWord, isCode) {
    let doList = '<option value="">選択してください</option>';
    let doCode = "";
    let doName = "";
    const doData = {
        do: getAllDo(),
    };
    for (let key in doData.do.do_data) {
        doCode = doData.do.do_data[key].do_code;
        doName = doData.do.do_data[key].do_name;
        if (searchWord === "" || doCode.match(searchWord) || doName.match(searchWord)) {
            if (isCode) {
                doList +=
                    '<option value="' + doCode + '">' + doCode + '</option>';
            }
            else {
                doList +=
                    '<option value="' + doName + '">' + doName + '</option>';
            }
        }
    }
    return doList;
}
